import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
// const SOCKET_URL = "ws://localhost:7202";
// const SOCKET_URL = "wss://aikalavya.com/api";

export function socketRequest(path, payload) {
  return new Promise((resolve, reject) => {
    const socket = new WebSocket(`${SOCKET_URL}${path}`);

    let hasResolved = false;
    let lastMessage = null;

    socket.onopen = () => {
      socket.send(JSON.stringify(payload));
    };

    socket.onmessage = (e) => {
      lastMessage = e.data;
      try {
        const parsed = JSON.parse(e.data);
        if (parsed.status === "completed" || parsed.error) {
          if (!hasResolved) {
            hasResolved = true;
            try {
              socket.close();
            } catch (err) {}
            if (parsed.error) {
              reject(new Error(parsed.error));
            } else {
              resolve(parsed);
            }
          }
        }
      } catch (err) {}
    };

    socket.onerror = (error) => {
      if (!hasResolved) {
        hasResolved = true;
        reject(error);
      }
    };

    socket.onclose = (event) => {
      if (hasResolved) return;
      hasResolved = true;

      if (lastMessage === null) {
        reject(
          new Error(
            `WebSocket closed before response (code=${event.code}, reason=${event.reason || "no reason"})`,
          ),
        );
        return;
      }

      try {
        const parsed = JSON.parse(lastMessage);
        resolve(parsed);
      } catch (error) {
        resolve(lastMessage);
      }
    };
  });
}

export const api = {
  socket: (url, payload) => socketRequest(url, payload),
};

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: "http://localhost:7202",
  // baseURL: "https://edlumina.wizzgeeks.com/api",
  // baseURL: "https://aikalavya.com/api/",
});

export const adminAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_BASE_URL,
  // baseURL: "https://edluminaadmin.wizzgeeks.com/api",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now();

        if (decoded.exp * 1000 < currentTime) {
          console.warn("Token expired, redirecting...");
          Cookies.remove("accessToken");
          Cookies.remove("user");

          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
          return Promise.reject(new Error("Token expired"));
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }

      config.headers.Authorization = `${token}`;
    }

    const storedUser = Cookies.get("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.admin && config.method === "get") {
          config.params = { ...config.params, admin: true };
        }
      } catch (e) {
        console.error("Error parsing user from session storage", e);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(
        "API Error:",
        error.response.config.url,
        error.response.status,
        error.response.data,
      );

      if (error.response.status === 401) {
        Cookies.remove("accessToken");
        Cookies.remove("user");

        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    } else {
      console.error("Network Error:", error.message);
    }
    return Promise.reject(error);
  },
);

adminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken");

    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

adminAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(
        "Admin API Error:",
        error.response.config.url,
        error.response.status,
        error.response.data,
      );
      if (error.response.status === 401) {
        Cookies.remove("accessToken");
        Cookies.remove("user");
      }
    }
    return Promise.reject(error);
  },
);

export const LOGIN_URL = "/api/users/login";
export const TEACHER_LOGIN_URL = "/api/users/teacher/login";
export const LOGOUT_URL = "/api/users/logout";
export const FORGOT_PASSWORD_URL = "/api/users/forgot-password";
export const RESET_TOKEN_VERIFICATION_URL = "/api/users/reset-token-verification";
export const RESET_PASSWORD_URL = "/api/users/reset-password";

export const GET_ALL_COURSES = "/api/users/course/get/all";
export const GET_COURSE_BY_KEY = "/api/users/course/get";

export const GET_ALL_SUBJECTS = "/api/users/subject/get/all";
export const GET_SUBJECT_BY_KEY = "/api/users/subject/get";

export const GET_ALL_TOPICS = "/api/users/topic/get/all";
export const GET_TOPIC_BY_KEY = "/api/users/topic/get";

export const GET_ALL_SUBTOPICS = "/api/users/subtopic/get/all";
export const GET_SUBTOPIC_BY_KEY = "/api/users/subtopic/get";

export const GET_ALL_COURSE_PAGE_CONTENT =
  "/api/users/course-page-content/get/all";
export const GET_COURSE_PAGE_CONTENT_BY_ID =
  "/api/users/course-page-content/get";

export const GET_ALL_SUBJECT_PAGE_CONTENT =
  "/api/users/subject-page-content/get/all";
export const GET_SUBJECT_PAGE_CONTENT_BY_ID =
  "/api/users/subject-page-content/get";

export const GET_ALL_TOPIC_PAGE_CONTENT =
  "/api/users/topic-page-content/get/all";
export const GET_TOPIC_PAGE_CONTENT_BY_ID = "/api/users/topic-page-content/get";

export const GET_ALL_SUBTOPIC_PAGE_CONTENT =
  "/api/users/subtopic-page-content/get/all";
export const GET_SUBTOPIC_PAGE_CONTENT_BY_ID =
  "/api/users/subtopic-page-content/get";

export const GET_BREADCRUMBS = "/api/users/get_breadcrumps";
export const SEARCH_API = "/api/users/search";
export const AI_TUTOR_URL = "/api/users/ai-tutor/teach";
export const GET_CONVERSATION_ANALYSIS = "/api/users/conversation";
export const GET_CONTENT_CONVERSATION = "/api/users/content-conversation";

export const USER_UPDATE_URL = "/api/users/update";

export const GET_PREFERENCE_URL = "/api/user/preference-questions/get";
export const GET_ALL_INITIAL_TEST =
  "/api/users/initial_onboarding_test/get/all";
export const GET_INITIAL_TEST = "/api/users/initial_onboarding_test/get";

export const GET_MATERIAL_FOLDER_URL = `/api/user/materials-folders/get`;
export const GET_MATERIALS_URL = `/api/user/materials/get/all`;
export const GET_MATERIAL_URL = `/api/user/materials/get`;

export const GET_MATERIAL_INSTITUTION_FOLDER_URL = `/api/user/materials-institution-folders/get`;
export const GET_MATERIALS_INSTITUTION_URL = `/api/user/materials-institution/get/all`;
export const GET_MATERIAL_INSTITUTION_URL = `/api/user/materials-institution/get`;

export const GET_FOLDER_URL = `/api/user/question-bank-folder/get`;
export const GET_QUESTION_BANKS_URL = `/api/user/question-banks/get/all`;
export const GET_ONE_QUETION_BANK_URL = `/api/user/question-banks/get`;
export const SUBMIT_QUESTION_BANK_URL = `/api/user/question-banks/submit`;
export const GET_QUESTION_BANK_RESULT_URL = `/api/user/question-banks/result`;
export const QUESTION_BANK_COMPLETE_SUBMIT_URL = `/api/user/question-bank-complete/submit`;

export const GET_INSTITUTION_FOLDER_URL = `/api/user/question-bank-institution-folder/get`;
export const GET_INSTITUTION_QUESTION_BANKS_URL = `/api/user/question-bank-institution/get/all`;
export const GET_ONE_INSTITUTION_QUESTION_BANK_URL = `/api/user/question-bank-institution/get`;
export const SUBMIT_INSTITUTION_QUESTION_BANK_URL = `/api/user/question-bank-institution/submit`;
export const GET_INSTITUTION_QUESTION_BANK_RESULT_URL = `/api/user/question-bank-institution/result`;
export const QUESTION_BANK_INSTITUTION_COMPLETE_SUBMIT_URL = `/api/user/question-bank-institution/submit`;

export const GET_USER_PROFILE_URL = "/api/users/profile/get";
export const UPDATE_USER_PROFILE_URL = "/api/users/profile/update";
export const CHANGE_USER_PASSWORD_URL = "/api/users/profile/change-password";

export const TEST_SUBMIT_URL = "/api/test-results/submit";
export const QUIZ_SUBMIT_URL = "/api/quiz-results/submit";
export const QUIZ_RESULT_GET_URL = "/api/quiz/get/result";
export const TEST_GET_URL = "/api/test/get/data";
export const AI_GENERATE_TEST_URL = "/ws/llm/generate/test";
export const NOTIFICATION_URL = `${SOCKET_URL}/ws/notification`;

export const GET_ALL_COMPLETED_COURSE_URL = "/api/users/course/completed/get";
export const UPDATE_COMPLETED_COURSE_URL = "/api/users/course/completed/submit";
export const GET_ALL_COMPLETED_SUBJECT_URL = "/api/users/subject/completed/get";
export const UPDATE_COMPLETED_SUBJECT_URL =
  "/api/users/subject/completed/submit";
export const GET_ALL_COMPLETED_TOPIC_URL = "/api/users/topic/completed/get";
export const UPDATE_COMPLETED_TOPIC_URL = "/api/users/topic/completed/submit";
export const GET_ALL_COMPLETED_SUBTOPIC_URL =
  "/api/users/subtopic/completed/get";
export const GET_ONE_SUBTOPIC_COMPLETED_URL =
  "/api/users/subtopic/completed/get/by_id";
export const GET_ONE_TOPIC_COMPLETED_URL =
  "/api/users/topic/completed/get/by_id";
export const GET_ONE_SUBJECT_COMPLETED_URL =
  "/api/users/subject/completed/get/by_id";
export const GET_ONE_COURSE_COMPLETED_URL =
  "/api/users/course/completed/get/by_id";
export const UPDATE_COMPLETED_SUBTOPIC_URL =
  "/api/users/subtopic/completed/submit";

export const GET_COURSE_SUBJECT_SUMMARY_URL =
  "/api/users/course/completed/subject-summary";
export const GET_SUBJECT_TOPIC_SUMMARY_URL =
  "/api/users/subject/completed/topic-summary";
export const GET_TOPIC_SUBTOPIC_SUMMARY_URL =
  "/api/users/topic/completed/subtopic-summary";

export const UPDATE_TIME_SPENT_URL = "/api/users/time_spent/update";

export const TEACHER_UPDATE_COMPLETED_COURSE_URL =
  "/api/teacher/course/completed/submit";
export const TEACHER_UPDATE_COMPLETED_SUBJECT_URL =
  "/api/teacher/subject/completed/submit";
export const TEACHER_UPDATE_COMPLETED_TOPIC_URL =
  "/api/teacher/topic/completed/submit";
export const TEACHER_UPDATE_COMPLETED_SUBTOPIC_URL =
  "/api/teacher/subtopic/completed/submit";

export const TEACHER_GET_COMPLETED_COURSE_URL =
  "/api/teacher/course/completed/get";
export const TEACHER_GET_COMPLETED_SUBJECT_URL =
  "/api/teacher/subject/completed/get";
export const TEACHER_GET_COMPLETED_TOPIC_URL =
  "/api/teacher/topic/completed/get";
export const TEACHER_GET_COMPLETED_SUBTOPIC_URL =
  "/api/teacher/subtopic/completed/get";

export const REATTEMPT_TEST_URL = "/api/test/reattempt";

export const GET_DASHBOARD_DATA = "/api/users/dashboard/get/all";
export const GET_DASHBOARD_OVERVIEW = "/api/users/dashboard/get/all/overview";
export const GET_DASHBOARD_ANALYTICS = "/api/users/dashboard/get/all/analytics";
export const GET_COURSE_DASHBOARD_OVERVIEW =
  "/api/users/dashboard/course/get/overview";
export const GET_COURSE_DASHBOARD_ANALYTICS =
  "/api/users/dashboard/course/get/analytics";
export const GET_SUBJECT_DASHBOARD_OVERVIEW =
  "/api/users/dashboard/subject/get/overview";
export const GET_SUBJECT_DASHBOARD_ANALYTICS =
  "/api/users/dashboard/subject/get/analytics";
export const GET_TOPIC_DASHBOARD_OVERVIEW =
  "/api/users/dashboard/topic/get/overview";
export const GET_TOPIC_DASHBOARD_ANALYTICS =
  "/api/users/dashboard/topic/get/analytics";
export const GET_SUBTOPIC_DASHBOARD_OVERVIEW =
  "/api/users/dashboard/subtopic/get/overview";
export const GET_SUBTOPIC_DASHBOARD_ANALYTICS =
  "/api/users/dashboard/subtopic/get/analytics";
export const GET_SUBJECT_TEST_COMPLETED_DETAILS =
  "/api/users/dashboard/test-complete/subject/get";
export const GET_SUBJECT_ACTIVE_RECALL_COMPLETED_DETAILS =
  "/api/users/dashboard/active-recall/subject/get";
export const GET_SUBJECT_ADAPTIVE_LEARNING_COMPLETED_DETAILS =
  "/api/users/dashboard/adaptive-learning/subject/get";
export const GET_SUBJECT_QUIZ_COMPLETED_DETAILS =
  "/api/users/dashboard/quiz/subject/get";
export const GET_BADGES_URL = "/api/users/badges/get";
export const GET_COINS_URL = "/api/users/coins/get";
export const GET_XP_URL = "/api/users/xp/get";

export const GET_ALL_ADAPTIVE_LEARNING_CONTENT =
  "/api/users/adaptive-learning/get/all";
export const GET_ADAPTIVE_LEARNING_CONTENT_BY_ID =
  "/api/users/adaptive-learning/get";
export const GET_USER_MILESTONES_URL = "/api/users/milestones/get";
export const UPDATE_USER_MILESTONES_URL = "/api/users/milestones/update";
export const CREATE_USER_MILESTONES_URL = "/api/users/milestones/create";

export const ACTIVE_RECALL_COMPLETED_URL = "/api/users/active-recall/completed";
export const GET_ACTIVE_RECALL_COMPLETED_URL =
  "/api/users/active-recall/get-completed";
export const GET_ACTIVE_RECALL_URL = "/user/active-recall/triggers";
export const GET_ACTIVE_RECALL_DAYS_URL = "/api/user/active-recall-days";
export const UPDATE_ACTIVE_RECALL_DAYS_URL =
  "/api/user/active-recall-days/update";

export const GET_PENDING_URL = "/api/users/get/pending";
export const GET_ADAPTIVE_LEARNING = "/api/users/adaptive-learning/get";
export const GET_ADAPTIVE_LEARNING_CONTENT =
  "/api/users/adaptive-learning/content";
export const GET_ADAPTIVE_LEARNING_TEST = "/api/users/adaptive-learning/test";
export const SUBMIT_ADAPTIVE_LEARNING_TEST =
  "/api/users/adaptive-learning/test/submit";
export const REGENERATE_ADAPTIVE_LEARNING_CONTENT =
  "/api/users/adaptive-learning/regenerate";


export const GET_HOME_WORKS_URL = "/api/users/homework/get/all";
export const GET_HOME_WORK_URL = "/api/users/homework/get";
export const SUBMIT_HOME_WORK_URL = "/api/users/homework/submit";
export const GET_COMPLETED_HOME_WORK_URL = "/api/users/homework/submission/get";

export const GET_ALL_OVERALL_MATERIALS = "/api/users/overall-materials/get/all";
export const GET_OVERALL_MATERIAL_BY_ID = "/api/users/overall-materials/get";

export const GET_ALL_COURSE_BLOGS = "/api/users/course-blog/get/all";
export const GET_COURSE_BLOG_BY_ID = "/api/users/course-blog/get";

export const GET_ALL_OVERALL_COURSE_TEST =
  "/api/user/overall-course-test/get/all";
export const GET_OVERALL_COURSE_TEST_BY_ID =
  "/api/user/overall-course-test/get";
export const SUBMIT_OVERALL_COURSE_TEST =
  "/api/user/overall-course-test/submit";
export const GET_OVERALL_COURSE_TEST_SUBMISSION =
  "/api/user/overall-course-test/submission/get";

export const GET_OVERALL_COURSE_TEST_PENDING_COUNT =
  "/api/users/overall-course-test/get/pending/count";

export const GET_GAMES_URL = "/api/users/games/completed/get/all_except_user";
export const GET_ONE_GAME_URL =
  "/api/users/games/completed/get/all_except_user/one";
export const GENERATE_GAME_URL = "/api/users/games/generate";
export const CREATE_COMPLETED_GAME_URL = "/api/users/games/completed/create";

export const MARK_AS_READ_URL = `/api/users/notification/markasread/update`;

export const GET_ALL_VIDEOS = "/api/users/videos/get/all";
export const GET_VIDEO_BY_ID = "/api/users/videos/get/one";

export const GENERATE_PERSONALIZED_CONTENT_COURSE =
  "/ws/llm/course-personalized-content/generate";
export const GENERATE_PERSONALIZED_CONTENT_SUBJECT =
  "/ws/llm/subject-personalized-content/generate";
export const GENERATE_PERSONALIZED_CONTENT_TOPIC =
  "/ws/llm/topic-personalized-content/generate";
export const GENERATE_PERSONALIZED_CONTENT_SUBTOPIC =
  "/ws/llm/subtopic-personalized-content/generate";

export const CREATE_PERSONALIZED_CONTENT_COURSE =
  "/api/users/course-personalized-content/create";
export const CREATE_PERSONALIZED_CONTENT_SUBJECT =
  "/api/users/subject-personalized-content/create";
export const CREATE_PERSONALIZED_CONTENT_TOPIC =
  "/api/users/topic-personalized-content/create";
export const CREATE_PERSONALIZED_CONTENT_SUBTOPIC =
  "/api/users/subtopic-personalized-content/create";

export const GET_PERSONALIZED_CONTENT_COURSE =
  "/api/users/course-personalized-content/get";
export const GET_PERSONALIZED_CONTENT_SUBJECT =
  "/api/users/subject-personalized-content/get";
export const GET_PERSONALIZED_CONTENT_TOPIC =
  "/api/users/topic-personalized-content/get";
export const GET_PERSONALIZED_CONTENT_SUBTOPIC =
  "/api/users/subtopic-personalized-content/get";

export const GENERATE_AUDIO_BOOK = `/ws/generate/speech`;

export const GET_ALL_COURSE_INSTITUTION_PAGE_CONTENT =
  "/api/users/course-institution-page-content/get/all";
export const GET_COURSE_INSTITUTION_PAGE_CONTENT_BY_ID =
  "/api/users/course-institution-page-content/get";
export const GET_ALL_SUBJECT_INSTITUTION_PAGE_CONTENT =
  "/api/users/subject-institution-page-content/get/all";
export const GET_SUBJECT_INSTITUTION_PAGE_CONTENT_BY_ID =
  "/api/users/subject-institution-page-content/get";

export const GET_ALL_TOPIC_INSTITUTION_PAGE_CONTENT =
  "/api/users/topic-institution-page-content/get/all";
export const GET_TOPIC_INSTITUTION_PAGE_CONTENT_BY_ID =
  "/api/users/topic-institution-page-content/get";

export const GET_ALL_SUBTOPIC_INSTITUTION_PAGE_CONTENT =
  "/api/users/subtopic-institution-page-content/get/all";
export const GET_SUBTOPIC_INSTITUTION_PAGE_CONTENT_BY_ID =
  "/api/users/subtopic-institution-page-content/get";

export const SUBMIT_CONTENT_QUIZ_URL = "/api/content-quiz/submit";
export const REGENERATE_CONTENT_QUIZ_URL = "/api/content-quiz/regenerate";

export const GET_USER_AI_EVAL_DETAILS_URL = "/api/users/ai-eval/get-details";
export const GET_USER_AI_EVAL_ALL_URL = "/api/users/ai-eval/get-all";
export const GET_USER_AI_EVAL_TEST_URL = "/api/users/ai-eval/get-test-evals";
export const GET_USER_AI_EVAL_QUIZ_URL = "/api/users/ai-eval/get-quiz-evals";
export const GET_USER_AI_EVAL_CONTENT_URL = "/api/users/ai-eval/get-content-evals";
export const GET_USER_AI_EVAL_TUTOR_URL = "/api/users/ai-eval/get-tutor-evals";
export const REGENERATE_USER_AI_EVAL_TEST_URL = "/api/users/ai-eval/regenerate-test-eval";
